import { connect } from 'react-redux';
import { actions } from '@amplement/backend-connector';
import { closeModal } from 'actions/modal';
import { MODAL_DELETE_ACCOUNT } from 'types/modal';
import DeleteAccountModal from './index';

const mapDispatchToProps = (dispatch, { _currentUser }) => ({
    onClose: () => dispatch(closeModal(MODAL_DELETE_ACCOUNT)),
    onSubmit: () => dispatch(actions.session.requestDeleteUser(_currentUser))
});

export default connect(null, mapDispatchToProps)(DeleteAccountModal);
